import merge from 'lodash/merge';
import App from './views/App.svelte';
import StatisticsService from "./services/survey-statistics.service";
import DataProvider from "./providers/data.provider";
import ServiceProvider from "./providers/service.provider";
class StatisticsModule {
    constructor(options) {
        this.options = options;
    }
    mount() {
        try {
            this.prepareOptions();
            this.dataProvider = new DataProvider(this.options);
            const searchService = new StatisticsService(this.dataProvider);
            this.serviceProvider = new ServiceProvider(searchService);
            this.createInstance();
        }
        catch (e) {
            console.log(e);
        }
    }
    createInstance() {
        new App({
            target: this.targetElement,
            props: {
                serviceProvider: this.serviceProvider,
            }
        });
    }
    get targetElement() {
        const { el } = this.options;
        const element = document.querySelector(el);
        if (null === element) {
            throw new Error("The container for displaying Survey statistics does not exist");
        }
        return element;
    }
    // OPTIONS
    prepareOptions() {
        this.options = merge({}, {
            el: null,
        }, this.options);
    }
}
const elementStatistics = document.getElementById('app-survey-statistics');
if (elementStatistics) {
    const statisticsApp = new StatisticsModule({ el: '#app-survey-statistics' });
    statisticsApp.mount();
}
